import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { WorkScheduleExemption } from '@apaq/orgkit-js';
import { DialogService } from 'src/app/modules/dialog/dialog.service';
import { AbsenceDatasource } from '../absence-datasource';
import { Data, ExemptionEditorDialogComponent } from './exemption-editor-dialog/exemption-editor-dialog.component';

@Component({
  selector: 'ws-exemption-editor',
  templateUrl: './exemption-editor.component.html',
  styleUrls: ['./exemption-editor.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: ExemptionEditorComponent,
      multi: true
    }]
})
export class ExemptionEditorComponent implements AfterViewInit, ControlValueAccessor {

  @ViewChild('absence') absenceCalendar?: ElementRef;
  absenceDatasource?: AbsenceDatasource;
  exemptions?: WorkScheduleExemption[];
  onChange?: (exemptions: WorkScheduleExemption[]) => void;

  constructor(private dialogService: DialogService) { }

  ngAfterViewInit(): void {
    if(this.absenceCalendar?.nativeElement.dataSource == null) {
      this.updateDatasource();
    }
  }

  writeValue(exemptions: WorkScheduleExemption[]): void {
    this.exemptions = exemptions;
    this.updateDatasource();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void { }

  updateDatasource() {
    if(this.absenceCalendar) {
      this.absenceDatasource = new AbsenceDatasource(null!, this.exemptions!);
      this.absenceCalendar!.nativeElement.dataSource = this.absenceDatasource;
    }
  }

  onSchedulerClick(event: MouseEvent) {
    this.absenceCalendar!.nativeElement.getEventProperties(event).then((props: any) => {
      if(props?.dateEvents?.length > 0) {
        const dateEvent = props.dateEvents[0];
        const exemption = dateEvent.exemption;
        this.editAbsence(exemption);
      }
    });
  }

  onAddAbsence() {
    this.editAbsence();
  }

  private editAbsence(exemption?: WorkScheduleExemption) {
    const title = exemption ? $localize`Edit Absence` : $localize`Add Absence`;
    const data: Data | undefined = exemption ? { exemption } : undefined;
    this.dialogService.open(ExemptionEditorDialogComponent, title, {data}).afterClosed().subscribe(result => {
      if(result) {
        const action = result.action;
        switch(action) {
          case 'Save':
            if(exemption) {
              const index = this.exemptions!.indexOf(exemption);
              this.exemptions!.splice(index, 1);
            }
            this.exemptions?.push(result.entity);
            this.updateDatasource();
            break;
          case 'Delete':
            if(exemption) {
              const index = this.exemptions!.indexOf(exemption);
              this.exemptions!.splice(index, 1);
            }
            this.updateDatasource();
            break;
        }

        if(this.onChange) {
          this.onChange(this.exemptions!);
        }
      }
    });
  }

}
